// Runtime polyfills for older WebViews (Android Chrome < 92 lacks Array.prototype.at).
import 'core-js/actual/array/at'
import { installCssZoomRects } from '@/utils/css-zoom-rects'

// WebKit before Safari 26.4 divides client rects by the CSS zoom (bug 185034).
installCssZoomRects()
